// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.leaflet-container {
  height: 100vh;
}

/* Transiciones globales */
.transition-all {
  transition: all 0.2s ease-in-out;
}

/* Estilos para navegación en modal */
.modal-nav-button {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  transition: all 0.2s;
  cursor: pointer;
}

.modal-nav-button:hover:not(:disabled) {
  background-color: #f8f9fa;
  color: #1a73e8;
  border-color: #1a73e8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.modal-nav-button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.modal-nav-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* Visor de imágenes optimizado */
.zoom-viewer-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1a1a1a;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.zoom-image-element {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  will-change: transform;
  -webkit-user-drag: none;
}

.zoom-controls-overlay {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.2);
  padding: 5px;
  border-radius: 8px;
  backdrop-filter: blur(4px);
}

.zoom-btn {
  width: 34px;
  height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 6px !important;
}

/* Skeletons Premium */
@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.skeleton-item {
  height: 20px;
  width: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 2s infinite linear;
  display: inline-block;
}

/* Estilos de Tabla Mejorados - ¡Llenando de vida! */
.contenedor-scroll-tabla-list {
  overflow-y: auto !important;
  overflow-x: auto !important;
  position: relative;
  max-height: 480px;
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
}

.ctable-list {
  border-collapse: separate !important;
  border-spacing: 0 !important;
  width: 100% !important;
}

.ctable-list tbody tr {
  transition: background-color 0.15s ease !important;
  cursor: pointer;
  background-color: #fff;
}

/* --- Chart Distribution Widget --- */
.chart-distribution-widget {
  animation: fadeIn 0.4s ease-out;
}

.border-start-lg {
  border-left: 1px solid #e2e8f0;
}

@media (max-width: 991.98px) {
  .border-start-lg {
    border-left: none;
    border-top: 1px solid #e2e8f0;
    padding-top: 1rem;
  }
}

.badge-distribution {
  font-size: 0.6rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: #f1f5f9;
  color: #475569;
  border-radius: 4px;
  padding: 4px 8px;
}

.ctable-list tbody td {
  padding: 12px !important;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9 !important;
}



/* El efecto de ELEVACIÓN sin cortes laterales */
.ctable-list tbody tr:hover:not(.row-viewed-highlight) {
  background-color: #f8fafc !important;
  position: relative;
  z-index: 5;
}


/* Resaltado de fila seleccionada - Más limpio y profesional */
.row-viewed-highlight {
  background-color: rgba(61, 153, 235, 0.05) !important;
}

.row-viewed-highlight td {
  font-weight: 600 !important;
  color: #1a73e8 !important;
}

.row-viewed-highlight td:first-child {
  box-shadow: inset 4px 0 0 #3d99eb !important;
}



/* --- VIDA EXTRA PARA LA PÁGINA --- */

/* Stats Cards interactivas */
.stats-card {
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
  border: 1px solid transparent;
}

.stats-card:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
  border-color: rgba(61, 153, 235, 0.2);
}

.stats-card.active {
  background-color: #fff;
}

/* Micro-animaciones en botones de acción */
.btn-action-round {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.btn-action-round:hover {
  transform: scale(1.2) rotate(5deg);
  filter: brightness(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Botón de descarga con efecto pulse sutil al pasar el mouse */
.btn-descargar-list {
  transition: all 0.3s ease !important;
}

.btn-descargar-list:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
}

/* Modern Back Button Style */
.modern-back-button {
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: white !important;
  border: 1px solid #edeff2 !important;
  color: #3c4b64 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modern-back-button:hover {
  transform: translateX(-5px);
  background: #f8f9fa !important;
  color: #1a73e8 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  border-color: #3d99eb !important;
}

/* --- PREMIUM MODAL UI --- */
.premium-modal-unified .modal-content {
  border-radius: 20px !important;
  overflow: hidden;
  border: none !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.modal-header-premium {
  background: #131133 !important;
  color: white !important;
  border-bottom: none;
}

.modal-header-premium .fw-bold.text-primary {
  color: #ffffff !important;
}

.modal-header-premium .CButton {
  filter: invert(1) brightness(2);
}


.info-modern-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #edf2f7;
  transition: all 0.3s ease;
}

.info-modern-card:hover {
  border-color: #3d99eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.info-modern-label {
  display: block;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #718096;
  font-weight: 700;
  margin-bottom: 2px;
}

.info-modern-value {
  display: block;
  font-size: 0.9rem;
  color: #2d3748;
  line-height: 1.4;
}

.badge-status-pill {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.section-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #edf2f7, transparent);
  margin: 15px 0;
}

.sidebar-info-container {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f7fafc;
}

.sidebar-info-container::-webkit-scrollbar {
  width: 6px;
}

.sidebar-info-container::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 10px;
}

.btn-premium-action {
  border-radius: 12px !important;
  padding: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

.btn-premium-action:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(26, 115, 232, 0.2);
}

.address-box {
  background: #f8fafc;
  border-left: 4px solid #3d99eb;
  padding: 8px 12px;
  border-radius: 0 8px 8px 0;
}

.coord-box {
  background: #2d3748;
  color: #edf2f7;
  padding: 6px 12px;
  border-radius: 8px;
  font-family: 'JetBrains Mono', 'Fira Code', monospace;
  font-size: 0.75rem;
}

.additional-info-box {
  background: #fffaf0;
  border: 1px solid #feebc8;
  border-radius: 12px;
}

/* Fix sticky headers for tables - Professional Look */
.sticky-header-detail th,
.sticky-header th,
.modern-table thead th,
.ctable-list thead th {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important;
  background-color: #131133 !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  padding: 14px 12px !important;
  border-bottom: none !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  transform: none !important;
  opacity: 1 !important;
}

.sticky-header-detail,
.sticky-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  border-bottom: none !important;
}

/* Buscador y Sub-filtros Premium */
.buscador-senales-container {
  background: white;
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  max-width: 100%;
  box-sizing: border-box;
}

.search-input-custom {
  border-radius: 10px !important;
  border: 1px solid #e2e8f0 !important;
  padding: 10px 14px !important;
  transition: all 0.3s ease !important;
}

.search-input-custom:focus {
  border-color: #3d99eb !important;
  box-shadow: 0 0 0 4px rgba(61, 153, 235, 0.1) !important;
}

.sub-filters-section {
  border-top: 1px solid #f1f5f9;
}

.btn-sub-filter-pill {
  white-space: nowrap;
  padding: 8px 18px;
  border-radius: 20px;
  border: 1px solid #edf2f7;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.btn-sub-filter-pill:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #334155;
}

.btn-sub-filter-pill.active {
  background: #131133;
  border-color: #131133;
  color: white;
  box-shadow: 0 4px 12px rgba(19, 17, 51, 0.2);
}

/* Stats Cards Premium - Diseño compacto para 7 en fila */
.stats-cards-container {
  width: 100%;
}

.stats-card-premium {
  flex: 1 1 140px; /* Base width to fit 7 in ~1000px-1200px */
  max-width: 180px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.stats-card-premium:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.08);
  border-color: #3d99eb;
}

.stats-card-premium.active {
  border-color: #131133;
  background-color: #f8fafc;
  box-shadow: 0 4px 12px rgba(19, 17, 51, 0.1);
  transform: scale(1.02);
}

.stats-card-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stats-card-icon-wrapper {
  background: #f1f5f9;
  padding: 6px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats-card-premium.active .stats-card-icon-wrapper {
  background: #131133;
}

.stats-card-premium.active .stats-card-icon {
  filter: brightness(0) invert(1);
}

.stats-card-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.stats-card-info {
  display: flex;
  flex-direction: column;
}

.stats-card-label {
  font-size: 0.7rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.stats-card-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.current-value {
  font-size: 1.1rem;
  font-weight: 800;
  color: #1e293b;
}

.total-label {
  font-size: 0.6rem;
  color: #94a3b8;
  font-weight: 600;
}

/* SubFilterProgressBar Premium Styles */
.progress-bar-stack-premium {
  display: flex;
  height: 12px;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f1f5f9;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  margin: 8px 0;
}

.progress-segment-premium {
  height: 100%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.progress-segment-premium:last-child {
  border-right: none;
}

.progress-segment-premium:hover {
  filter: brightness(1.1);
  transform: scaleY(1.2);
  z-index: 2;
}

.segment-label-premium {
  font-size: 0.6rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

.x-small {
  font-size: 0.6rem;
}

.sub-filter-progress-container {
  animation: slideDownIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideDownIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.btn-action-round-sm {
  width: 26px;
  height: 26px;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 50% !important;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0 !important;
  transition: all 0.2s ease;
}

.btn-action-round-sm:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* Coming Soon Badge and Disabled Stats Card */
.coming-soon-badge-premium {
  font-size: 0.45rem;
  background-color: #ffc107;
  color: #000;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 6px;
  vertical-align: middle;
  font-weight: 800;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.stats-card-premium.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  filter: grayscale(0.8);
  border-style: dashed;
}

.stats-card-premium.disabled:hover {
  transform: none;
  box-shadow: none;
  border-color: #e2e8f0;
}

/* --- RESPONSIVE POLISH --- */
@media (max-width: 768px) {
  .margin-row-contenedor {
    margin: 10px 0 !important;
    width: auto;
  }

  .stats-card-premium {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 15px);
    min-width: 120px; /* Reducido de 140 para evitar desbordamientos */
    max-width: none !important;
  }
  
  .buscador-senales-container {
    padding: 12px;
  }

  .ctable-list {
    min-width: 800px;
  }

  .search-input-wrapper {
    margin-bottom: 4px;
  }
}

@media (max-width: 480px) {
  .stats-card-premium {
    flex: 1 1 100% !important;
    min-width: 0;
  }

  .btn-descargar-list span {
    display: none;
  }
  
  .buscador-senales-container {
    padding: 12px;
    margin: 0;
    width: auto;
  }

  .buscador-senales-container .ms-auto {
    margin-left: 0 !important;
    margin-top: 8px;
    width: 100%;
    justify-content: space-between;
  }
}

.detail-index-main-wrapper {
  overflow-x: hidden !important;
  width: 100%;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,2CAA2C;AAC7C;;;;AAIA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;AACZ;;;AAGA,8DAA8D;AAC9D;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;;;AAIA,sCAAsC;;AAEtC,6BAA6B;AAC7B;EACE,4DAA4D;EAC5D,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,4DAA4D;AAC9D;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA,+DAA+D;AAC/D;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,4DAA4D;EAC5D,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qEAAqE;EACrE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;;;;EAIE,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,wDAAwD;EACxD,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA,yDAAyD;AACzD;EACE,WAAW;AACb;;AAEA;EACE,eAAe,EAAE,0CAA0C;EAC3D,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,YAAqC;IAArC,cAAqC;IAArC,4BAAqC;IACrC,gBAAgB,EAAE,gDAAgD;IAClE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.leaflet-container {\n  height: 100vh;\n}\n\n/* Transiciones globales */\n.transition-all {\n  transition: all 0.2s ease-in-out;\n}\n\n/* Estilos para navegación en modal */\n.modal-nav-button {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid #dee2e6;\n  background: white;\n  color: #495057;\n  transition: all 0.2s;\n  cursor: pointer;\n}\n\n.modal-nav-button:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  color: #1a73e8;\n  border-color: #1a73e8;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.modal-nav-button:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.modal-nav-container {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n/* Visor de imágenes optimizado */\n.zoom-viewer-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #1a1a1a;\n  touch-action: none;\n  user-select: none;\n}\n\n.zoom-image-element {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  will-change: transform;\n  -webkit-user-drag: none;\n}\n\n.zoom-controls-overlay {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: flex;\n  gap: 8px;\n  z-index: 10;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 5px;\n  border-radius: 8px;\n  backdrop-filter: blur(4px);\n}\n\n.zoom-btn {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  border-radius: 6px !important;\n}\n\n/* Skeletons Premium */\n@keyframes skeleton-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.skeleton-item {\n  height: 20px;\n  width: 100%;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 2s infinite linear;\n  display: inline-block;\n}\n\n/* Estilos de Tabla Mejorados - ¡Llenando de vida! */\n.contenedor-scroll-tabla-list {\n  overflow-y: auto !important;\n  overflow-x: auto !important;\n  position: relative;\n  max-height: 480px;\n  background-color: #fff;\n  -webkit-overflow-scrolling: touch;\n}\n\n.ctable-list {\n  border-collapse: separate !important;\n  border-spacing: 0 !important;\n  width: 100% !important;\n}\n\n.ctable-list tbody tr {\n  transition: background-color 0.15s ease !important;\n  cursor: pointer;\n  background-color: #fff;\n}\n\n/* --- Chart Distribution Widget --- */\n.chart-distribution-widget {\n  animation: fadeIn 0.4s ease-out;\n}\n\n.border-start-lg {\n  border-left: 1px solid #e2e8f0;\n}\n\n@media (max-width: 991.98px) {\n  .border-start-lg {\n    border-left: none;\n    border-top: 1px solid #e2e8f0;\n    padding-top: 1rem;\n  }\n}\n\n.badge-distribution {\n  font-size: 0.6rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  background: #f1f5f9;\n  color: #475569;\n  border-radius: 4px;\n  padding: 4px 8px;\n}\n\n.ctable-list tbody td {\n  padding: 12px !important;\n  vertical-align: middle;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n\n\n/* El efecto de ELEVACIÓN sin cortes laterales */\n.ctable-list tbody tr:hover:not(.row-viewed-highlight) {\n  background-color: #f8fafc !important;\n  position: relative;\n  z-index: 5;\n}\n\n\n/* Resaltado de fila seleccionada - Más limpio y profesional */\n.row-viewed-highlight {\n  background-color: rgba(61, 153, 235, 0.05) !important;\n}\n\n.row-viewed-highlight td {\n  font-weight: 600 !important;\n  color: #1a73e8 !important;\n}\n\n.row-viewed-highlight td:first-child {\n  box-shadow: inset 4px 0 0 #3d99eb !important;\n}\n\n\n\n/* --- VIDA EXTRA PARA LA PÁGINA --- */\n\n/* Stats Cards interactivas */\n.stats-card {\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.stats-card:hover {\n  transform: translateY(-8px) scale(1.03);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);\n  border-color: rgba(61, 153, 235, 0.2);\n}\n\n.stats-card.active {\n  background-color: #fff;\n}\n\n/* Micro-animaciones en botones de acción */\n.btn-action-round {\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.btn-action-round:hover {\n  transform: scale(1.2) rotate(5deg);\n  filter: brightness(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Botón de descarga con efecto pulse sutil al pasar el mouse */\n.btn-descargar-list {\n  transition: all 0.3s ease !important;\n}\n\n.btn-descargar-list:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\n}\n\n/* Modern Back Button Style */\n.modern-back-button {\n  border-radius: 12px !important;\n  padding: 10px 20px !important;\n  font-weight: 600 !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  background: white !important;\n  border: 1px solid #edeff2 !important;\n  color: #3c4b64 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.modern-back-button:hover {\n  transform: translateX(-5px);\n  background: #f8f9fa !important;\n  color: #1a73e8 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;\n  border-color: #3d99eb !important;\n}\n\n/* --- PREMIUM MODAL UI --- */\n.premium-modal-unified .modal-content {\n  border-radius: 20px !important;\n  overflow: hidden;\n  border: none !important;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;\n}\n\n.modal-header-premium {\n  background: #131133 !important;\n  color: white !important;\n  border-bottom: none;\n}\n\n.modal-header-premium .fw-bold.text-primary {\n  color: #ffffff !important;\n}\n\n.modal-header-premium .CButton {\n  filter: invert(1) brightness(2);\n}\n\n\n.info-modern-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 12px;\n  border: 1px solid #edf2f7;\n  transition: all 0.3s ease;\n}\n\n.info-modern-card:hover {\n  border-color: #3d99eb;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.info-modern-label {\n  display: block;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #718096;\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.info-modern-value {\n  display: block;\n  font-size: 0.9rem;\n  color: #2d3748;\n  line-height: 1.4;\n}\n\n.badge-status-pill {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.section-divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #edf2f7, transparent);\n  margin: 15px 0;\n}\n\n.sidebar-info-container {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e0 #f7fafc;\n}\n\n.sidebar-info-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-info-container::-webkit-scrollbar-thumb {\n  background-color: #cbd5e0;\n  border-radius: 10px;\n}\n\n.btn-premium-action {\n  border-radius: 12px !important;\n  padding: 12px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.3px;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n}\n\n.btn-premium-action:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 15px rgba(26, 115, 232, 0.2);\n}\n\n.address-box {\n  background: #f8fafc;\n  border-left: 4px solid #3d99eb;\n  padding: 8px 12px;\n  border-radius: 0 8px 8px 0;\n}\n\n.coord-box {\n  background: #2d3748;\n  color: #edf2f7;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-family: 'JetBrains Mono', 'Fira Code', monospace;\n  font-size: 0.75rem;\n}\n\n.additional-info-box {\n  background: #fffaf0;\n  border: 1px solid #feebc8;\n  border-radius: 12px;\n}\n\n/* Fix sticky headers for tables - Professional Look */\n.sticky-header-detail th,\n.sticky-header th,\n.modern-table thead th,\n.ctable-list thead th {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 100 !important;\n  background-color: #131133 !important;\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  padding: 14px 12px !important;\n  border-bottom: none !important;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n  transform: none !important;\n  opacity: 1 !important;\n}\n\n.sticky-header-detail,\n.sticky-header {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1000 !important;\n  border-bottom: none !important;\n}\n\n/* Buscador y Sub-filtros Premium */\n.buscador-senales-container {\n  background: white;\n  padding: 16px 20px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.search-input-custom {\n  border-radius: 10px !important;\n  border: 1px solid #e2e8f0 !important;\n  padding: 10px 14px !important;\n  transition: all 0.3s ease !important;\n}\n\n.search-input-custom:focus {\n  border-color: #3d99eb !important;\n  box-shadow: 0 0 0 4px rgba(61, 153, 235, 0.1) !important;\n}\n\n.sub-filters-section {\n  border-top: 1px solid #f1f5f9;\n}\n\n.btn-sub-filter-pill {\n  white-space: nowrap;\n  padding: 8px 18px;\n  border-radius: 20px;\n  border: 1px solid #edf2f7;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n}\n\n.btn-sub-filter-pill:hover {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n  color: #334155;\n}\n\n.btn-sub-filter-pill.active {\n  background: #131133;\n  border-color: #131133;\n  color: white;\n  box-shadow: 0 4px 12px rgba(19, 17, 51, 0.2);\n}\n\n/* Stats Cards Premium - Diseño compacto para 7 en fila */\n.stats-cards-container {\n  width: 100%;\n}\n\n.stats-card-premium {\n  flex: 1 1 140px; /* Base width to fit 7 in ~1000px-1200px */\n  max-width: 180px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.02);\n}\n\n.stats-card-premium:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 20px rgba(0,0,0,0.08);\n  border-color: #3d99eb;\n}\n\n.stats-card-premium.active {\n  border-color: #131133;\n  background-color: #f8fafc;\n  box-shadow: 0 4px 12px rgba(19, 17, 51, 0.1);\n  transform: scale(1.02);\n}\n\n.stats-card-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.stats-card-icon-wrapper {\n  background: #f1f5f9;\n  padding: 6px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stats-card-premium.active .stats-card-icon-wrapper {\n  background: #131133;\n}\n\n.stats-card-premium.active .stats-card-icon {\n  filter: brightness(0) invert(1);\n}\n\n.stats-card-icon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.stats-card-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stats-card-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.stats-card-value {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.current-value {\n  font-size: 1.1rem;\n  font-weight: 800;\n  color: #1e293b;\n}\n\n.total-label {\n  font-size: 0.6rem;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n/* SubFilterProgressBar Premium Styles */\n.progress-bar-stack-premium {\n  display: flex;\n  height: 12px;\n  width: 100%;\n  border-radius: 6px;\n  overflow: hidden;\n  background-color: #f1f5f9;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n  margin: 8px 0;\n}\n\n.progress-segment-premium {\n  height: 100%;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  border-right: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.progress-segment-premium:last-child {\n  border-right: none;\n}\n\n.progress-segment-premium:hover {\n  filter: brightness(1.1);\n  transform: scaleY(1.2);\n  z-index: 2;\n}\n\n.segment-label-premium {\n  font-size: 0.6rem;\n  font-weight: 800;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n}\n\n.x-small {\n  font-size: 0.6rem;\n}\n\n.sub-filter-progress-container {\n  animation: slideDownIn 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideDownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.btn-action-round-sm {\n  width: 26px;\n  height: 26px;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50% !important;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0 !important;\n  transition: all 0.2s ease;\n}\n\n.btn-action-round-sm:hover {\n  background-color: #f1f5f9;\n  border-color: #cbd5e1 !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n}\n\n/* Coming Soon Badge and Disabled Stats Card */\n.coming-soon-badge-premium {\n  font-size: 0.45rem;\n  background-color: #ffc107;\n  color: #000;\n  padding: 1px 4px;\n  border-radius: 4px;\n  margin-left: 6px;\n  vertical-align: middle;\n  font-weight: 800;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n\n.stats-card-premium.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  filter: grayscale(0.8);\n  border-style: dashed;\n}\n\n.stats-card-premium.disabled:hover {\n  transform: none;\n  box-shadow: none;\n  border-color: #e2e8f0;\n}\n\n/* --- RESPONSIVE POLISH --- */\n@media (max-width: 768px) {\n  .margin-row-contenedor {\n    margin: 10px 0 !important;\n    width: auto;\n  }\n\n  .stats-card-premium {\n    flex: 1 1 calc(50% - 15px) !important;\n    min-width: 120px; /* Reducido de 140 para evitar desbordamientos */\n    max-width: none !important;\n  }\n  \n  .buscador-senales-container {\n    padding: 12px;\n  }\n\n  .ctable-list {\n    min-width: 800px;\n  }\n\n  .search-input-wrapper {\n    margin-bottom: 4px;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-card-premium {\n    flex: 1 1 100% !important;\n    min-width: 0;\n  }\n\n  .btn-descargar-list span {\n    display: none;\n  }\n  \n  .buscador-senales-container {\n    padding: 12px;\n    margin: 0;\n    width: auto;\n  }\n\n  .buscador-senales-container .ms-auto {\n    margin-left: 0 !important;\n    margin-top: 8px;\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n.detail-index-main-wrapper {\n  overflow-x: hidden !important;\n  width: 100%;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
